import {
  AbstractControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
} from "@angular/forms";
import { CheckoutValidationMessages } from "app/_components/checkout-validation/checkout-validation.messages";
import {
  CheckoutFormGroup
} from "app/_components/checkout/checkout.component";

const validateContactName = (): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const checkoutFormGroup = control.root as FormGroup<CheckoutFormGroup>;
    const contactNameValue = checkoutFormGroup.value.smsOpt?.contactName ?? "";
    if (contactNameValue.length > 50) {
      return { "smsOpt.contactName.maxlength": CheckoutValidationMessages["smsOptContactName.maxlength"] };
    }
    return null;
  };
};

const validateMobileNumber = (): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const checkoutFormGroup = control.root as FormGroup<CheckoutFormGroup>;
    const mobileNumberValue = checkoutFormGroup.value.smsOpt?.mobileNumber ?? "";
    if (mobileNumberValue.length > 20) {
      return { "smsOpt.mobileNumber.maxlength": CheckoutValidationMessages["smsOptMobileNumber.maxlength"] };
    }
    return null;
  };
};

export const smsOptValidators: ValidatorFn[] = [
  validateContactName(),
  validateMobileNumber(),
];
